// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filter-pill{min-width:50px;margin-left:5px;margin-right:5px}", ""]);
// Exports
module.exports = exports;
